$(document).ready(function () {
    // Add smooth scrolling to all links in browsers which don't support it via CSS
    if (getComputedStyle(document.body).scrollBehavior !== 'smooth' && !window.disableSmoothScroll) {
        $(document).on('click', 'a', function (event) {
            // Make sure this.hash has a value before overriding default behavior
            if (this.href && this.href[0] === '#' && this.hash !== '') {
                // Prevent default anchor click behavior
                event.preventDefault();
                // Store hash
                const hash = this.hash;
                // Using jQuery's animate() method to add smooth page scroll
                // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
                $('html, body').animate({
                    scrollTop: $(hash).offset().top,
                }, 400, function () {
                    // Add hash (#) to URL when done scrolling (default click behavior)
                    window.location.hash = hash;
                });
            }
        });
    }
});
